<template lang="pug">
button.gap-2.align-items-center(
  v-bind="$attrs"
  :type="props.buttonType || 'button'"
  :class="$attrs.class"
)
  span(v-if="props.text") {{ props.text }}
  slot(name="icon")
</template>

<script setup lang="ts">
import { type ButtonInteractiveProps } from './ButtonInteractive.types';
import { buttonInteractiveDefaults } from './ButtonInteractive.defaults';

const props = withDefaults(
  defineProps<ButtonInteractiveProps>(),
  buttonInteractiveDefaults,
);
</script>
